import { memo } from 'react';
import Pds08Locale from 'locale/en/pds08.json';
import Url from 'lib/siteurls';
import { useInView } from 'react-intersection-observer';
import { createGlobalStyle } from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';

const imageUrl = `${Url.cloudinary}/q_auto,c_fill,g_auto,f_auto/v1649281177/PDS%20PDP/`;

const ModalPDS08SustainabilityStyles = createGlobalStyle`
  #modal-pds08-sustainability {
  .section {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid var(--outline-primary);
    padding: var(--spacing-24) 0;
  }
  .section .text {
    @media ${mqLargeMin} {
      width: 31%;
    }
    width: 100%;

    ul {
      list-style-type: none;
      list-style-position: outside;
      padding: 15px 0 0 0;
    }
    li {
      margin: var(--spacing-24) 0 0;
      font-size: var(--font-size-400);
      position: relative;
      font-weight: 400;
      display: block;

      @media ${mqLargeMin} {
        padding: 0 0 0 var(--spacing-24);
      }
    }
    .img {
      width: 100%;
      display: block;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-color: var(--fill-secondary);
      background-blend-mode: multiply;
      @media ${mqLargeMin} {
        display: none;
      }
      &:after {
        font-size: var(--font-size-400);
        position: absolute;
        top: 0;
        right: 0;
      }
      &.i1 {
        transform: translateX(6%);
        padding-bottom: 80%;
        &:after {
          top: -2%;
          right: 12%;
          content: '1';
        }
        &:before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 40px;
          z-index: 1;
        }
        @media (max-width: 992px) {
          background-size: 55% auto;
          background-position-x: 43%;
          background-position-y: 50%;
          padding-top: 40px;
          &:after {
            top: -3%;
            right: 30%;
            content: '1';
          }
        }
      }
      &.i2 {
        padding-bottom: 80%;
        background-size: 140% auto;
        transform: translateY(-20px);
        &:after {
          top: 22%;
          right: 32%;
          content: '2';
        }
        @media (max-width: 992px) {
          background-size: 60% auto;
          background-position-x: 65%;
          background-position-y: 75%;
          padding-top: 50px;
          &:after {
            top: 13%;
            right: 22%;
            content: '2';
          }
        }
      }
      &.i3 {
        padding-bottom: 70%;
        background-size: 120% auto;
        transform: translateY(-20px);
        &:after {
          top: 17%;
          right: 39%;
          content: '3';
        }
        @media (max-width: 992px) {
          background-size: 75% auto;
          background-position-x: 52%;
          background-position-y: 50%;
          padding-top: 50px;
          &:after {
            top: 14%;
            right: 30%;
            content: '3';
          }
        }
      }
      &.i4 {
        padding-bottom: 80%;
        background-size: 105% auto;
        transform: translateX(10%);
        &:after {
          top: -3%;
          right: 19%;
          content: '4';
        }
        @media (max-width: 992px) {
          background-size: 70% auto;
          background-position-x: 15%;
          background-position-y: 50%;
          padding-top: 50px;
          &:after {
            top: 12%;
            right: 24%;
            content: '4';
          }
        }
      }
      &.i5 {
        padding-bottom: 90%;
        &:after {
          top: 14%;
          right: 22%;
          content: '5';
        }
        @media (max-width: 992px) {
          background-size: 40% auto;
          background-position-x: 50%;
          background-position-y: 50%;
          padding-top: 50px;
          &:after {
            top: 10%;
            right: 31%;
            content: '5';
          }
        }
      }
    }
    .int {
      transform: translate(-2px, -8px);
      padding: 0 calc(10px / 2) 0 0;
      font-size: var(--font-size-300);
      display: inline-block;
      font-weight: 400;
      @media ${mqLargeMin} {
        transform: translateY(-2px);
        padding: 0 var(--spacing-8) 0 0;
        padding: 0;
        position: absolute;
        top: 5px;
        left: 0;
      }
    }
  }
  .section .media {
    display: none;
    width: 60%;
    background: transparent;
    flex-wrap: wrap;
    @media ${mqLargeMin} {
      display: flex;
      padding: var(--spacing-48) 0 0;
    }

    .img {
      position: relative;
      width: 50%;
      padding-bottom: 40%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 65% auto;
      background-color: var(--fill-secondary);
      background-blend-mode: multiply;
    }
    .i1 {
      z-index: 1;
      height: 100%;
      margin-left: -50px;
      padding-bottom: 0%;
    }
    .i2 {
      margin-top: -180px;
      background-size: 50% auto;
      z-index: -1;
    }
    .i3 {
      margin-left: 260px;
      margin-top: -200px;
      background-size: 80% auto;
    }
    .i4 {
      transform: translateX(8%);
      background-size: 70% auto;
      margin-left: -40px;
    }
    .i5 {
      background-size: auto 90%;
      background-position: center;
      margin-left: -20px;
    }

    i {
      font-style: normal;
      position: absolute;
    }
    .i1 i {
      top: -4%;
      left: 82%;
    }
    .i2 i {
      top: 32%;
      left: 78%;
    }
    .i3 i {
      top: 22%;
      left: 79%;
    }
    .i4 i {
      top: -6%;
      left: 81%;
    }
    .i5 i {
      left: 78%;
      top: -6%;
    }
  }
  .section.s2 {
    margin-top: var(--spacing-48);
    padding: var(--spacing-24) 0 200px;
  }
  .section.s2 .media {
    @media ${mqLargeMin} {
      padding: 45px 0 0;
    }
  }
}
`;

const ModalPDS08Sustainability = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  return (
    <>
      <ModalPDS08SustainabilityStyles />
      <div className='head'>
        <div className='title'>{Pds08Locale.pds_08_daily_synbiotic}</div>
        <span>{Pds08Locale.sustainability}</span>
      </div>
      <div ref={ref} className='section s1'>
        <div className='text'>
          <strong>{Pds08Locale.welcome_kit}</strong>
          <ul>
            <li>
              <div
                className='img i1'
                style={{
                  backgroundImage: inView
                    ? `url(${imageUrl}sustainability_learn_more_1.png)`
                    : 'none',
                }}
              />
              <span className='int'>1</span>
              <span>{Pds08Locale.biofilm}</span>
            </li>
            <li>
              <div
                className='img i2'
                style={{
                  backgroundImage: inView
                    ? `url(${imageUrl}sustainability_learn_more_2.png)`
                    : 'none',
                }}
              />
              <span className='int'>2</span>
              <span>{Pds08Locale.your_bio}</span>
            </li>
            <li>
              <div
                className='img i3'
                style={{
                  backgroundImage: inView
                    ? `url(${imageUrl}sustainability_learn_more_3.png)`
                    : 'none',
                }}
              />
              <span className='int'>3</span>
              <span>{Pds08Locale.aluminum}</span>
            </li>
          </ul>
        </div>
        <div className='media'>
          <div
            className='img i1'
            style={{
              backgroundImage: inView
                ? `url(${imageUrl}sustainability_learn_more_1.png)`
                : 'none',
            }}
          >
            <i>1</i>
          </div>
          <div
            className='img i2'
            style={{
              backgroundImage: inView
                ? `url(${imageUrl}sustainability_learn_more_2.png)`
                : 'none',
            }}
          >
            <i>2</i>
          </div>
          <div
            className='img i3'
            style={{
              backgroundImage: inView
                ? `url(${imageUrl}sustainability_learn_more_3.png)`
                : 'none',
            }}
          >
            <i>3</i>
          </div>
        </div>
      </div>
      <div className='section s2'>
        <div className='text'>
          <strong>{Pds08Locale.monthly_refill}</strong>
          <ul>
            <li>
              <div
                className='img i4'
                style={{
                  backgroundImage: inView
                    ? `url(${imageUrl}sustainability_learn_more_5.png)`
                    : 'none',
                }}
              />
              <span className='int'>4</span>
              <span>{Pds08Locale.our_home}</span>
            </li>
          </ul>
        </div>
        <div className='media'>
          <div
            className='img i5'
            style={{
              backgroundImage: inView
                ? `url(${imageUrl}sustainability_learn_more_5.png)`
                : 'none',
            }}
          >
            <i>4</i>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ModalPDS08Sustainability);
